'use client';

/**
 * Hybrid Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { AdvantagesSection } from '../common/advantages-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { Zap, UserPlus, Settings, Award, Target, DollarSign } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.hybridPlan.hero"
                imageSrc="/images/mlm-plans/Hybrid_tree_animation.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.hybridPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.hybridPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.hybridPlan.features" />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.hybridPlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3', 'advantage4', 'advantage5']}
                gridCols="3"
            />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.hybridPlan.commissions"
                commissions={[
                    { icon: Zap, color: 'primary', titleKey: 'fastStart.title', descriptionKey: 'fastStart.description' },
                    { icon: UserPlus, color: 'blue', titleKey: 'sponsor.title', descriptionKey: 'sponsor.description' },
                    { icon: Settings, color: 'green', titleKey: 'custom.title', descriptionKey: 'custom.description' },
                ]}
                gridCols="3"
            />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.hybridPlan.whySoftware" />
        </div>
    );
}

